document.addEventListener("DOMContentLoaded", function() {

	//this will contain the last time a request was run (to prevent multiple firing at once)
	let last_request = 0;

	//this bool will help the change function determine what to update when it's called on results page load
	let results_refresh = false;

	//check whether this is the commercial page
	let commercial = document.body.classList.contains('post-type-archive-tyre');

	//checks whether the tyre result filters are available - these are only present if a tyre has results
	let has_commercial_results = document.getElementById('tyre-results-controls');

	//we will populate this depending on the page
	inputs = get_inputs();

    //if we have some width inputs
	if(inputs['width'] && inputs['width'].length > 0) {

        //loop over each width input
        for(let i = 0; i < inputs['width'].length; i++) {

            //add an event listener
            inputs['width'][i].onchange = function(event) {
                dropdown_steps(event.target);
            };
        }
	}

    //if we have some profile inputs
	if(inputs['profile'] && inputs['profile'].length > 0) {

        //loop over each profile input
        for(let i = 0; i < inputs['profile'].length; i++) {

            //add an event listener
            inputs['profile'][i].onchange = function(event) {
                dropdown_steps(event.target);
            };
        }
	}

    //if we have some rim inputs
	if(inputs['rim'] && inputs['rim'].length > 0) {

        //loop over each rim input
        for(let i = 0; i < inputs['rim'].length; i++) {

            //add an event listener
            inputs['rim'][i].onchange = function(event) {
                dropdown_steps(event.target);
            };

            //if this is the commercial page and we have some results...
            if(commercial && has_commercial_results) {

                //call the function for this
                dropdown_steps(inputs['rim'][i]);
            }
        }
	}

    //if we have some category inputs
	if(inputs['category'] && inputs['category'].length > 0) {

        //loop over each profile input
        for(let i = 0; i < inputs['category'].length; i++) {

            //add an event listener
            inputs['category'][i].onchange = function(event) {
                dropdown_steps(event.target);
            };
        }
	}

	let edit_reg_button = document.getElementById('edit-reg');
	let edit_tyres_button = document.getElementById('edit-tyres');
	let edit_postcode_button = document.getElementById('edit-tyres-postcode');

	if(edit_reg_button || (edit_tyres_button || edit_postcode_button)) {

		if(edit_tyres_button) {
			edit_tyres_button.onclick = force_refresh_inputs;
		}

		if(edit_postcode_button) {
			edit_postcode_button.onclick = force_refresh_inputs;
		}
	}

	//defines a list of triggers that will cause the dropdowns to load
	let interactivity_triggers = [
		'scroll',
		'mousedown',
		'mousemove',
		'mouseover',
		'keydown',
	];

	//defines a function that will trigger once the page becomes active
	let force_refresh_inputs_ineractivity = function (event) {

		//refresh the inputs
		force_refresh_inputs();

		//loop over each event listener
		interactivity_triggers.forEach(function(event) {

			//remove it
			window.removeEventListener(event, force_refresh_inputs_ineractivity, false );
		});
	};

	//loop over each event listener
	interactivity_triggers.forEach(function(event) {

		//add it
		window.addEventListener(event, force_refresh_inputs_ineractivity, false);
	});

	function dropdown_steps(target) {

        //find the closest form
        let form = target.closest('form');

        //attempt to fetch the section from the form
        let section = form.getAttribute('data-section') ?? 'commercial';

		let stylesheet = document.getElementById('bt-sizes-dropdown-logic');

		if(!stylesheet) {
			document.head.insertAdjacentHTML("beforeend", `<style id="bt-sizes-dropdown-logic"></style>`);
			stylesheet = document.getElementById('bt-sizes-dropdown-logic');
		}

		//creates a change event we can use to kick select2
		let change_event = new Event('change');

        //if we have a valid target
        if(target) {

            //if this is the width input
            if((target.id).startsWith('tyre-width-') || target.id === 'tyre-agri-width') {

                //loop over each of our width inputs
                for(let i = 0; i < inputs['width'].length; i++) {

                    //ensure all other width inputs are set to the same value
                    inputs['width'][i].value = target.value;
                }

                //loop over each of our profile inputs
                for(let i = 0; i < inputs['profile'].length; i++) {

                    //reset the profile value
                    inputs['profile'][i].value = '';
                    inputs['profile'][i].dispatchEvent(change_event);
                    apply_inactive_classes(inputs['profile'][i]);
                }

                //loop over each of our rim inputs
                for(let i = 0; i < inputs['rim'].length; i++) {

                    //reset rim value
                    inputs['rim'][i].value = '';
                    inputs['rim'][i].dispatchEvent(change_event);
                    apply_inactive_classes(inputs['rim'][i]);
                }

                if(inputs['speed'] && inputs['speed'].length > 0) {

                    //loop over each of our speed inputs
                    for(let i = 0; i < inputs['speed'].length; i++) {

                        //finally, reset speed value
                        inputs['speed'][i].value = '';
                        inputs['speed'][i].dispatchEvent(change_event);
                        apply_inactive_classes(inputs['speed'][i]);
                    }
                }

                if(inputs['category'] && inputs['category'].length > 0) {

                    //loop over each of our category inputs
                    for(let i = 0; i < inputs['category'].length; i++) {

                        //finally, reset category value
                        inputs['category'][i].value = '';
                        inputs['category'][i].dispatchEvent(change_event);
                    }
                }

            } else if((target.id).startsWith('tyre-profile-') || target.id === 'tyre-agri-profile') {

                //loop over each of our profile inputs
                for(let i = 0; i < inputs['profile'].length; i++) {

                    //ensure all other profile inputs are set to the same value
                    inputs['profile'][i].value = target.value;
                }

                //loop over each of our rim inputs
                for(let i = 0; i < inputs['rim'].length; i++) {

                    //reset the rim value
                    inputs['rim'][i].value = '';
                    inputs['rim'][i].dispatchEvent(change_event);
                    apply_inactive_classes(inputs['rim'][i]);
                }

                //if we have some speed inputs
                if(inputs['speed'] && inputs['speed'].length > 0) {

                    //loop over each of our speed inputs
                    for(let i = 0; i < inputs['speed'].length; i++) {

                        //reset the speed value
                        inputs['speed'][i].value = '';
                        inputs['speed'][i].dispatchEvent(change_event);
                        apply_inactive_classes(inputs['speed'][i]);
                    }
                }

                //if we have some category inputs
                if(inputs['category'] && inputs['category'].length > 0) {

                    //loop over each of our category inputs
                    for(let i = 0; i < inputs['category'].length; i++) {
                        inputs['category'][i].value = '';
                        inputs['category'][i].dispatchEvent(change_event);
                    }
                }

            } else if((target.id).startsWith('tyre-rim-') || target.id === 'tyre-agri-rim') {

                //loop over each of our rim inputs
                for(let i = 0; i < inputs['rim'].length; i++) {

                    //ensure all other rim inputs are set to the same value
                    inputs['rim'][i].value = target.value;
                }

                //if we have some speed inputs
                if(inputs['speed'] && inputs['speed'].length > 0) {

                    //loop over each of our speed inputs
                    for(let i = 0; i < inputs['speed'].length; i++) {

                        //if this isn't an automatic refresh (changing the value will mess up automatically populated results)
                        if(!results_refresh) {

                            //reset the type value
                            inputs['speed'][i].value = '';
                        }

                        //reset the speed value
                        inputs['speed'][i].dispatchEvent(change_event);
                        apply_inactive_classes(inputs['speed'][i]);
                    }
                }

                if(inputs['category'] && inputs['category'].length > 0) {

                    //loop over each of our category inputs
                    for(let i = 0; i < inputs['category'].length; i++) {

                        inputs['category'][i].value = '';
                        inputs['category'][i].dispatchEvent(change_event);
                    }
                }
            }
        }

		//reset the refresh bool
		results_refresh = false;

		//if the value is currently 0 for this element
		if(target.value === "0") {

			//ensure our disabled classes are present until it's time to remove them
			(target.parentNode).classList.add('opacity-50');
			(target.parentNode).classList.add('pointer-events-none');
		}

		let current_time = Math.floor(Date.now() / 1000);

		if(last_request < (current_time - 1)) {

			last_request = (current_time - 1);

			const xhr = new XMLHttpRequest();
			xhr.addEventListener("readystatechange", function () {
				if (this.readyState === this.DONE) {

					//this will be the response from the backend
					let response = JSON.parse(this.responseText);

					//refresh inputs to get the latest data
					inputs = get_inputs();

					//this will contain our built styles to show/hide certain elements on the page
					let styles = '';

					//loop over each key sent back from the backend
					for(let type in response) {

						//if we have this key and there's some items to display
						if(response[type] && response[type].length > 0) {

							//store the type name from the response (as agriculture tyres have a different naming scheme)
							let response_type = type;

							//if we have speed data
							if(type === 'speed' || type === 'load' || type === 'ply' || type === 'oe_fit' || type === 'type') {

								//pass these to our function to filter options in the refine menu
								filter_refine_menu(type, response[type]);

							}

							if(inputs[type]) {

                                for(let i = 0; i < inputs[type].length; i++) {

                                    //fetch the current options of this dropdown
                                    let options = inputs[type][i].children;

                                    //if we have some options
                                    if(options) {

                                        //loop over the options
                                        for(let ii = 0; ii < options.length; ii++) {

                                            //attempt to fetch the original input
                                            let option_elements = document.querySelectorAll('select[id^="tyre-' + type + '"] option[value="' + options[ii].value + '"], #tyre-agri-' + type + ' option[value="' + options[ii].value + '"]');

                                            //if this option is not in the response array
                                            if(!(response[response_type]).includes(options[ii].value) || options[ii].value == '') {

                                                //if we have an element to target
                                                if(option_elements && (options[i].value != 0 && options[ii].value != "0" && options[ii].value != "")) {

                                                    //loop over each element
                                                    for(let iii = 0; iii < option_elements.length; iii++) {

                                                        //disable this element
                                                        option_elements[iii].setAttribute('disabled', '');
                                                    }
                                                }

                                                //build our styles that will hide this inputs that we don't want to use
                                                styles = styles + '#' + inputs[type][i].id + ' option[value="' + options[ii].value + '"] { display: none }';
                                                styles = styles + 'li[id^="select2-' + inputs[type][i].id + '-"][id$="-' + options[ii].value + '"] { display: none }';
                                            } else if(option_elements) { // otherwise it's a value that can be selected, so check if we have access to it first

                                                //loop over each element
                                                for(let iii = 0; iii < option_elements.length; iii++) {

                                                    //re-enable this element
                                                    option_elements[iii].removeAttribute('disabled');
                                                }
                                            }
                                        }
                                    }

                                    //loop over each input of this type
                                    for(let ii = 0; ii < inputs[type].length; ii++) {

                                        //find the parent of this element
                                        let parent = inputs[type][ii].closest('.tyre-select-container');

                                        //remove the disabled attribute if present
                                        inputs[type][ii].removeAttribute('disabled');

                                        //if we have found the parent
                                        if(parent) {

                                            //remove any classes making it non functional
                                            parent.classList.remove('opacity-50');
                                            parent.classList.remove('pointer-events-none');
                                        }
                                    }
                                }
							}
						}
					}

					//append our styles
					stylesheet.innerHTML = styles;
				}
			});

			xhr.open("POST", '/wp-json/laserred/tyres/dropdowns');
			xhr.setRequestHeader("Accept", "*/*");
			xhr.setRequestHeader("Content-Type", "application/json");

			//refresh inputs to get the latest data
			inputs = get_inputs();

			xhr.send(JSON.stringify({
				"agriculture": (section === 'agriculture'),
				"width": inputs['width'][0] ? inputs['width'][0].value : false,
				"profile": inputs['profile'][0] ? inputs['profile'][0].value : false,
				"rim": inputs['rim'][0] ? inputs['rim'][0].value : false,
				"speed": (section !== 'agriculture') ? (inputs['speed'][0] ? inputs['speed'][0].value : false) : ((inputs['type'] && inputs['type'].value) ? inputs['type'].value : false),
				"category": (section === 'agriculture') ? (inputs['category'] ? inputs['category'].value : false) : false,
			}));
		} else {
			console.warn('Too many dropdown requests, please wait.');
		}
	}

	function apply_inactive_classes(input) {
		(input.parentNode).classList.add('opacity-50');
		(input.parentNode).classList.add('pointer-events-none');
	}

	function filter_refine_menu(type, options) {

        console.log('refining for ' + type);

		//fetch any options for this type
		let refine_options = document.querySelectorAll('a[data-refine_option="' + type + '"]');

		//if we have a specific list of options to remove
		if(refine_options && refine_options.length > 0) {

			//loop over our options
			for(let i = 0; i < refine_options.length; i++) {

				//if this option isn't in the array OR we have no options to filter by
				if(options.includes(refine_options[i].dataset.refine_value) || options && options.length == 0 || !options) {

					//allow it
					refine_options[i].classList.add('refine-option-allowed');
				}
			}
		}
	}

	//define our function to update dropdowns
	let force_refresh_inputs = function() {

		//tell the change event that we're triggering this manually and to not update the speed dropdown
		results_refresh = true;

		//creates a change event we can use to kick select2
		let change_event = new Event('change');

		//we need to trigger a refresh on the last filled input, this will ensure all other inputs are only showing what can be changed based on each other's values
		//if the agri category is available
		if(inputs['category']) {

            //loop over each of our category inputs
            for(let i = 0; i < inputs['category'].length; i++) {

                inputs['category'][i].value = '';
                inputs['category'][i].dispatchEvent(change_event);
            }
		} else if(inputs['speed']) {

            //loop over each speed input
            for(let i = 0; i < inputs['speed'].length; i++) {

                //trigger a refresh on the speed element
			    inputs['speed'][i].dispatchEvent(change_event);
            }
		}
	}
});

function get_inputs() {

	return {
		'width': document.querySelectorAll('select[id^="tyre-width-"], #tyre-agri-width'),
		'profile': document.querySelectorAll('select[id^="tyre-profile-"], #tyre-agri-profile'),
		'rim': document.querySelectorAll('select[id^="tyre-rim-"], #tyre-agri-rim'),
		'speed': document.querySelectorAll('select[id^="tyre-speed-"], #tyre-agri-speed'),
		'category': document.querySelectorAll('select.search-category'),
	};
}